import React, { useState, useContext, useRef } from "react";
import "../../../constants/report.css";
import axios from "axios";
import { AuthContext } from "../../../contexts/AuthContext";
import {
  tempUrlFico,
  useStateContext,
} from "../../../contexts/ContextProvider";
import { Loader } from "../../../components";
import { Box, Typography, ButtonGroup, Button } from "@mui/material";
import { Container, Form, Row, Col } from "react-bootstrap";
import DatePicker from "react-datepicker";
import jsPDF from "jspdf";
import { useDownloadExcel } from "react-export-table-to-excel";
import SearchIcon from "@mui/icons-material/Search";
import PrintIcon from "@mui/icons-material/Print";
import { useReactToPrint } from "react-to-print";
import useScreenWidth from "../../../hooks/useScreenWidth";

const NeracaPercobaan = () => {
  const screenSize = useScreenWidth();
  const { user, dispatch, setting } = useContext(AuthContext);
  const tableRef = useRef(null);
  const reportTemplateRef = useRef(null);
  const [validated, setValidated] = useState(false);
  let nowDate = new Date();
  let [dariTanggal, setDariTanggal] = useState(
    new Date(user.tutupperiode.dariTanggal)
  );
  let [sampaiTanggal, setSampaiTanggal] = useState(
    new Date(user.tutupperiode.sampaiTanggal)
  );
  const [loading, setLoading] = useState(false);
  const [persenLoading, setPersenLoading] = useState("0");
  const [neracasData, setNeracasData] = useState([]);
  const [previewPdf, setPreviewPdf] = useState(false);
  const [isCetakExcel, setIsCetakExcel] = useState(false);

  const generatePDF = useReactToPrint({
    content: () => reportTemplateRef.current,
    documentTitle: "LaporanNeracaPercobaan",
  });

  const unposting = async (tempPersenLoading) => {
    // Jurnal Unposting
    await axios.post(`${tempUrlFico}/tempJurnalUnpostingRebuild`, {
      dariTanggal,
      sampaiTanggal,
      _id: user.id,
      token: user.token,
      kodeCabang: user.cabang.id,
    });
  };

  const posting = async (tempPersenLoading) => {
    // Jurnal Posting Jurnal Umum
    await axios.post(`${tempUrlFico}/saveTempJurnalPostingJurnalUmumRebuild`, {
      dariTanggal,
      sampaiTanggal,
      userIdInput: user.id,
      _id: user.id,
      token: user.token,
      kodeCabang: user.cabang.id,
    });
    tempPersenLoading += 5;
    setPersenLoading(tempPersenLoading.toString());
    // Jurnal Posting Approval
    await axios.post(`${tempUrlFico}/saveTempJurnalPostingApprovalRebuild`, {
      piutangNasabahGadai: setting.piutangNasabahGadai,
      pendapatanAdministrasiGadai: setting.pendapatanAdministrasiGadai,
      dariTanggal,
      sampaiTanggal,
      userIdInput: user.id,
      _id: user.id,
      token: user.token,
      kodeCabang: user.cabang.id,
    });
    tempPersenLoading += 5;
    setPersenLoading(tempPersenLoading.toString());
    // Jurnal Posting Topup
    await axios.post(`${tempUrlFico}/saveTempJurnalPostingTopupRebuild`, {
      piutangNasabahGadai: setting.piutangNasabahGadai,
      pendapatanAdministrasiGadai: setting.pendapatanAdministrasiGadai,
      dariTanggal,
      sampaiTanggal,
      userIdInput: user.id,
      _id: user.id,
      token: user.token,
      kodeCabang: user.cabang.id,
    });
    tempPersenLoading += 5;
    setPersenLoading(tempPersenLoading.toString());
    // Jurnal Posting Tebus
    await axios.post(`${tempUrlFico}/saveTempJurnalPostingTebusRebuild`, {
      piutangNasabahGadai: setting.piutangNasabahGadai,
      pendapatanBungaPinjGadai: setting.pendapatanBungaPinjGadai,
      pendDendaPiutangGadai: setting.pendDendaPiutangGadai,
      kasPenerimaanGadai: setting.kasPenerimaanGadai,
      dariTanggal,
      sampaiTanggal,
      userIdInput: user.id,
      _id: user.id,
      token: user.token,
      kodeCabang: user.cabang.id,
    });
    tempPersenLoading += 5;
    setPersenLoading(tempPersenLoading.toString());
    // Jurnal Posting Perpanjangan
    await axios.post(
      `${tempUrlFico}/saveTempJurnalPostingPerpanjanganRebuild`,
      {
        piutangNasabahGadai: setting.piutangNasabahGadai,
        pendapatanBungaPinjGadai: setting.pendapatanBungaPinjGadai,
        pendDendaPiutangGadai: setting.pendDendaPiutangGadai,
        pendapatanAdministrasiGadai: setting.pendapatanAdministrasiGadai,
        kasPenerimaanGadai: setting.kasPenerimaanGadai,
        dariTanggal,
        sampaiTanggal,
        userIdInput: user.id,
        _id: user.id,
        token: user.token,
        kodeCabang: user.cabang.id,
      }
    );
    // Jurnal Posting Cicilan
    await axios.post(`${tempUrlFico}/saveTempJurnalPostingCicilanRebuild`, {
      piutangNasabahGadai: setting.piutangNasabahGadai,
      dariTanggal,
      sampaiTanggal,
      userIdInput: user.id,
      _id: user.id,
      token: user.token,
      kodeCabang: user.cabang.id,
    });
    tempPersenLoading += 5;
    setPersenLoading(tempPersenLoading.toString());
    // Jurnal Posting Jual Agunan
    await axios.post(`${tempUrlFico}/saveTempJurnalPostingJualAgunan`, {
      coaKasKasir: setting.coaKasKasir,
      piutangNasabahGadai: setting.piutangNasabahGadai,
      pendapatanBungaPinjGadai: setting.pendapatanBungaPinjGadai,
      pendDendaPiutangGadai: setting.pendDendaPiutangGadai,
      pendPenjualanBarangGadai: setting.pendPenjualanBarangGadai,
      titipanNasabah: setting.titipanNasabah,
      kasPenerimaanGadai: setting.kasPenerimaanGadai,
      biayaKerugian: setting.biayaKerugian,
      dariTanggal,
      sampaiTanggal,
      userIdInput: user.id,
      _id: user.id,
      token: user.token,
      kodeCabang: user.cabang.id,
    });
    tempPersenLoading += 5;
    setPersenLoading(tempPersenLoading.toString());
    // Jurnal Posting Penerimaan Fidusia
    await axios.post(
      `${tempUrlFico}/saveTempJurnalPostingPenerimaanFidusiaRebuild`,
      {
        piutangNasabahFidusia: setting.piutangNasabahFidusia,
        pendapatanBungaPinjFidusia: setting.pendapatanBungaPinjFidusia,
        pendDendaPiutangFidusia: setting.pendDendaPiutangFidusia,
        pendPinaltiPiutangFidusia: setting.pendPinaltiPiutangFidusia,
        biayaKerugian: setting.biayaKerugian,
        kasPenerimaanFidusia: setting.kasPenerimaanFidusia,
        dariTanggal,
        sampaiTanggal,
        userIdInput: user.id,
        _id: user.id,
        token: user.token,
        kodeCabang: user.cabang.id,
      }
    );
    // Jurnal Posting Penerimaan Hutang Denda Fidusia
    await axios.post(
      `${tempUrlFico}/saveTempJurnalPostingPenerimaanHutangDendaFidusiaRebuild`,
      {
        pendDendaPiutangFidusia: setting.pendDendaPiutangFidusia,
        dariTanggal,
        sampaiTanggal,
        userIdInput: user.id,
        _id: user.id,
        token: user.token,
        kodeCabang: user.cabang.id,
      }
    );
    tempPersenLoading += 5;
    setPersenLoading(tempPersenLoading.toString());
    // Jurnal Posting Pengajuan Fidusia
    await axios.post(
      `${tempUrlFico}/saveTempJurnalPostingPengajuanFidusiaRebuild`,
      {
        piutangNasabahFidusia: setting.piutangNasabahFidusia,
        dariTanggal,
        sampaiTanggal,
        userIdInput: user.id,
        _id: user.id,
        token: user.token,
        kodeCabang: user.cabang.id,
      }
    );
    tempPersenLoading += 5;
    setPersenLoading(tempPersenLoading.toString());
    // Jurnal Posting Kas Masuk
    await axios.post(`${tempUrlFico}/saveTempJurnalPostingKasMasukRebuild`, {
      dariTanggal,
      sampaiTanggal,
      userIdInput: user.id,
      _id: user.id,
      token: user.token,
      kodeCabang: user.cabang.id,
    });
    tempPersenLoading += 5;
    setPersenLoading(tempPersenLoading.toString());
    // Jurnal Posting Kas Keluar
    await axios.post(`${tempUrlFico}/saveTempJurnalPostingKasKeluarRebuild`, {
      dariTanggal,
      sampaiTanggal,
      userIdInput: user.id,
      _id: user.id,
      token: user.token,
      kodeCabang: user.cabang.id,
    });
    tempPersenLoading += 5;
    setPersenLoading(tempPersenLoading.toString());
    // Jurnal Posting Bank Masuk
    await axios.post(`${tempUrlFico}/saveTempJurnalPostingBankMasukRebuild`, {
      dariTanggal,
      sampaiTanggal,
      userIdInput: user.id,
      _id: user.id,
      token: user.token,
      kodeCabang: user.cabang.id,
    });
    tempPersenLoading += 5;
    setPersenLoading(tempPersenLoading.toString());
    // Jurnal Posting Bank Keluar
    await axios.post(`${tempUrlFico}/saveTempJurnalPostingBankKeluarRebuild`, {
      dariTanggal,
      sampaiTanggal,
      userIdInput: user.id,
      _id: user.id,
      token: user.token,
      kodeCabang: user.cabang.id,
    });
    tempPersenLoading += 5;
    setPersenLoading(tempPersenLoading.toString());

    const allNeracaSaldo = await axios.post(
      `${tempUrlFico}/tempNeracaSaldoAboveTanggal`,
      {
        dariTanggal,
        sampaiTanggal,
        _id: user.id,
        token: user.token,
        kodeCabang: user.cabang.id,
      }
    );
    const deletedNeracaSaldoAboveTanggal = await axios.post(
      `${tempUrlFico}/deleteTempNeracaSaldoAboveTanggal`,
      {
        dariTanggal,
        sampaiTanggal,
        _id: user.id,
        token: user.token,
        kodeCabang: user.cabang.id,
      }
    );
    tempPersenLoading += 5;
    setPersenLoading(tempPersenLoading.toString());

    const groupedNeracaSaldo = allNeracaSaldo.data.reduce(
      (group, neracaSaldo) => {
        const { tglNeracaSaldo } = neracaSaldo;
        group[tglNeracaSaldo] = group[tglNeracaSaldo] ?? [];
        group[tglNeracaSaldo].push(neracaSaldo);
        return group;
      },
      {}
    );
    let keys = Object.keys(groupedNeracaSaldo);

    tempPersenLoading += 5;
    setPersenLoading(tempPersenLoading.toString());

    console.log(`dariTanggal: ${dariTanggal}`);
    console.log(`sampaiTanggal: ${sampaiTanggal}`);
    // Make Last Neraca Saldo
    await axios.post(`${tempUrlFico}/saveLastTempNeracaSaldoRebuild`, {
      dariTanggal,
      sampaiTanggal,
      userIdInput: user.id,
      _id: user.id,
      token: user.token,
      kodeCabang: user.cabang.id,
    });
    // Update Neraca Saldo Jurnal Posting
    await axios.post(
      `${tempUrlFico}/saveTempJurnalPostingNeracaSaldoRebuild2`,
      {
        dariTanggal,
        sampaiTanggal,
        userIdInput: user.id,
        _id: user.id,
        token: user.token,
        kodeCabang: user.cabang.id,
      }
    );
  };

  const postingLabaRugiPeriodeBerjalan = async (jumlah) => {
    let countNeracaSaldo = 0;
    try {
      setLoading(true);
      let tempPersenLoading = parseInt(persenLoading);
      // Jurnal Posting Laba Rugi Periode Berjalan
      await axios.post(
        `${tempUrlFico}/saveTempJurnalPostingLabaRugiPeriodeBerjalan`,
        {
          dariTanggal: user.tutupperiode.dariTanggal,
          sampaiTanggal: user.tutupperiode.sampaiTanggal,
          labaRugiPeriodeBerjalan: setting.labaRugiPeriodeBerjalan,
          accountPembalance: setting.accountPembalance,
          jumlah,
          namaPeriode: user.tutupperiode.namaPeriode,
          userIdInput: user.id,
          _id: user.id,
          token: user.token,
          kodeCabang: user.cabang.id,
        }
      );
      // tempPersenLoading += 30;
      // setPersenLoading(tempPersenLoading.toString());

      let tempDariTanggal = new Date(user.tutupperiode.dariTanggal);

      // Update Periode Lama
      let tempDariTgl =
        tempDariTanggal.getFullYear() +
        "-" +
        (tempDariTanggal.getMonth() + 1) +
        "-" +
        "1";
      let dariTanggal = tempDariTgl;

      var lastday = function (year, month) {
        let date = new Date(year, month + 1, 0);
        return date.getDate();
      };

      let sampaiTanggal =
        tempDariTanggal.getFullYear() +
        "-" +
        (tempDariTanggal.getMonth() + 1) +
        "-" +
        lastday(tempDariTanggal.getFullYear(), tempDariTanggal.getMonth());

      const allNeracaSaldo = await axios.post(
        `${tempUrlFico}/tempNeracaSaldoAboveTanggal`,
        {
          dariTanggal,
          sampaiTanggal,
          _id: user.id,
          token: user.token,
          kodeCabang: user.cabang.id,
        }
      );
      const deletedNeracaSaldoAboveTanggal = await axios.post(
        `${tempUrlFico}/deleteTempNeracaSaldoAboveTanggal`,
        {
          dariTanggal,
          sampaiTanggal,
          _id: user.id,
          token: user.token,
          kodeCabang: user.cabang.id,
        }
      );
      // tempPersenLoading += 30;
      // setPersenLoading(tempPersenLoading.toString());

      const groupedNeracaSaldo = allNeracaSaldo.data.reduce(
        (group, neracaSaldo) => {
          const { tglNeracaSaldo } = neracaSaldo;
          group[tglNeracaSaldo] = group[tglNeracaSaldo] ?? [];
          group[tglNeracaSaldo].push(neracaSaldo);
          return group;
        },
        {}
      );

      // for (let i = 0; i < allNeracaSaldo.data.length; i++) {
      //   // Delete tglBigger Neraca Saldo
      //   await axios.post(
      //     `${tempUrlFico}/deleteNeracaSaldo/${allNeracaSaldo.data[i].id}`,
      //     {
      //       _id: user.id,
      //       token: user.token,
      //       kodeCabang: user.cabang.id,
      //     }
      //   );
      //   countNeracaSaldo++;
      // }
      // tempPersenLoading += 30;
      // setPersenLoading(tempPersenLoading.toString());

      // for (let i = 0; i < countNeracaSaldo; i++) {
      for (let i = 0; i < Object.keys(groupedNeracaSaldo).length; i++) {
        // Make Last Neraca Saldo
        await axios.post(`${tempUrlFico}/saveLastTempNeracaSaldoRebuild`, {
          dariTanggal,
          sampaiTanggal,
          userIdInput: user.id,
          _id: user.id,
          token: user.token,
          kodeCabang: user.cabang.id,
        });
        // Update Neraca Saldo Jurnal Posting
        await axios.post(
          `${tempUrlFico}/saveTempJurnalPostingNeracaSaldoRebuild2`,
          {
            dariTanggal,
            sampaiTanggal,
            userIdInput: user.id,
            _id: user.id,
            token: user.token,
            kodeCabang: user.cabang.id,
          }
        );

        let tempDariTgl = new Date(dariTanggal);
        let newDariTgl = new Date(
          tempDariTgl.setMonth(tempDariTgl.getMonth() + 1)
        );
        tempDariTgl =
          newDariTgl.getFullYear() +
          "-" +
          (newDariTgl.getMonth() + 1) +
          "-" +
          "1";
        dariTanggal = tempDariTgl;

        sampaiTanggal =
          newDariTgl.getFullYear() +
          "-" +
          (newDariTgl.getMonth() + 1) +
          "-" +
          lastday(newDariTgl.getFullYear(), newDariTgl.getMonth());
      }
      // setPersenLoading("0");
      // setLoading(false);
      // setOpen(true);
    } catch (e) {
      alert(e);
    }
  };

  const tampilPdf = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    const form = e.currentTarget;
    if (form.checkValidity()) {
      setLoading(true);
      let tempPersenLoading = parseInt(persenLoading);

      await unposting(tempPersenLoading);

      await posting(tempPersenLoading);

      let labaRugis = await axios.post(`${tempUrlFico}/tempLabaRugisRebuild`, {
        kodeGroupPendapatan: setting.kodeGroupPendapatan,
        kodeGroupBiayaAtasPendapatan: setting.kodeGroupBiayaAtasPendapatan,
        kodeGroupPengeluaranOperasional:
          setting.kodeGroupPengeluaranOperasional,
        kodeGroupPendapatanLainLain: setting.kodeGroupPendapatanLainLain,
        kodeGroupBiayaLainLain: setting.kodeGroupBiayaLainLain,
        dariTanggal: user.tutupperiode.dariTanggal,
        sampaiTanggal: user.tutupperiode.sampaiTanggal,
        _id: user.id,
        token: user.token,
        kodeCabang: user.cabang.id,
      });

      if (labaRugis.data) {
        let tempSubTotal = 0;
        let tempTotal = 0;
        let totalPendapatan = 0;
        let totalBiaya = 0;
        let labaRugiOperasional = 0;

        let keys = Object.keys(labaRugis.data);

        for (let j = 0; j < Object.keys(labaRugis.data).length; j++) {
          let groupByKodeSubGroupCOA = labaRugis.data[keys[j]].reduce(
            (group, labaRugi) => {
              const { namaSubGroupCOA } = labaRugi;
              group[namaSubGroupCOA] = group[namaSubGroupCOA] ?? [];
              group[namaSubGroupCOA].push(labaRugi);
              return group;
            },
            {}
          );
          let keysSubGroup = Object.keys(groupByKodeSubGroupCOA);

          for (let j = 0; j < Object.keys(keysSubGroup).length; j++) {
            for (
              let k = 0;
              k < groupByKodeSubGroupCOA[keysSubGroup[j]].length;
              k++
            ) {
              tempSubTotal += parseInt(
                groupByKodeSubGroupCOA[keysSubGroup[j]][k].jumlah
              );
              tempTotal += parseInt(
                groupByKodeSubGroupCOA[keysSubGroup[j]][k].jumlah
              );
            }
            tempSubTotal = 0;
          }

          if (
            labaRugis.data[keys[j]][0].groupCOA === setting.kodeGroupPendapatan
          ) {
            totalPendapatan += tempTotal;
          } else if (
            labaRugis.data[keys[j]][0].groupCOA ===
            setting.kodeGroupBiayaAtasPendapatan
          ) {
            totalBiaya += tempTotal;
          } else if (
            labaRugis.data[keys[j]][0].groupCOA ===
            setting.kodeGroupPengeluaranOperasional
          ) {
            totalBiaya += tempTotal;
          } else if (
            labaRugis.data[keys[j]][0].groupCOA ===
            setting.kodeGroupPendapatanLainLain
          ) {
            totalPendapatan += tempTotal;
          } else if (
            labaRugis.data[keys[j]][0].groupCOA ===
            setting.kodeGroupBiayaLainLain
          ) {
            totalBiaya += tempTotal;
          }

          tempTotal = 0;
        }
        labaRugiOperasional = totalPendapatan - totalBiaya;
        console.log(labaRugiOperasional);

        if (
          new Date(user.tutupperiode.dariTanggal) >
          new Date(setting.programDariTanggal)
        ) {
          await postingLabaRugiPeriodeBerjalan(labaRugiOperasional);
        }
      }

      let neracas = await axios.post(`${tempUrlFico}/tempNeracas`, {
        groupAktivaLancar: setting.groupAktivaLancar,
        groupAktivaTetap: setting.groupAktivaTetap,
        groupKewajibanHutang: setting.groupKewajibanHutang,
        groupModalSaham: setting.groupModalSaham,
        dariTanggal,
        sampaiTanggal,
        _id: user.id,
        token: user.token,
        kodeCabang: user.cabang.id,
      });
      setNeracasData(neracas.data);
      setPreviewPdf(!previewPdf);
      setLoading(false);
      setPersenLoading("0");
    }
  };

  const tableText = {
    letterSpacing: "0.01px",
  };

  const list = [];
  let tempSubTotal = 0;
  let tempTotal = 0;

  let keys = Object.keys(neracasData);

  for (let j = 0; j < Object.keys(neracasData).length; j++) {
    list.push(
      <tr>
        <td style={{ fontWeight: 700, border: "1px solid black" }} colspan="4">
          {neracasData[keys[j]][0].jenisCOA} :
        </td>
      </tr>
    );
    let groupByKodeGroupCOA = neracasData[keys[j]].reduce((group, neraca) => {
      const { namaGroupCOA } = neraca;
      group[namaGroupCOA] = group[namaGroupCOA] ?? [];
      group[namaGroupCOA].push(neraca);
      return group;
    }, {});
    let keysSubGroup = Object.keys(groupByKodeGroupCOA);

    for (let j = 0; j < Object.keys(keysSubGroup).length; j++) {
      list.push(
        <>
          <tr>
            <td
              style={{
                fontWeight: 700,
                paddingLeft: "10px",
                border: "1px solid black",
              }}
              colspan="4"
            >
              {groupByKodeGroupCOA[keysSubGroup[j]][0].namaGroupCOA} :
            </td>
          </tr>
        </>
      );
      for (let k = 0; k < groupByKodeGroupCOA[keysSubGroup[j]].length; k++) {
        tempSubTotal += parseInt(
          groupByKodeGroupCOA[keysSubGroup[j]][k].jumlah
        );
        list.push(
          <tr>
            <td style={{ paddingLeft: "15px", border: "1px solid black" }}>
              {groupByKodeGroupCOA[keysSubGroup[j]][k].kodeCOA}
            </td>
            <td style={{ paddingLeft: "15px", border: "1px solid black" }}>
              {groupByKodeGroupCOA[keysSubGroup[j]][k].namaCOA}
            </td>
            {isCetakExcel === false ? (
              <td
                style={{
                  textAlign: "right",
                  width: "25%",
                  border: "1px solid black",
                }}
              >
                {groupByKodeGroupCOA[keysSubGroup[j]][k].jumlah > 0
                  ? parseInt(
                      groupByKodeGroupCOA[keysSubGroup[j]][k].jumlah
                    ).toLocaleString("en-EN")
                  : `(${parseInt(groupByKodeGroupCOA[keysSubGroup[j]][k].jumlah)
                      .toLocaleString("en-EN")
                      .slice(1)})`}
              </td>
            ) : (
              <td
                style={{
                  textAlign: "right",
                  width: "25%",
                  border: "1px solid black",
                }}
              >
                {groupByKodeGroupCOA[keysSubGroup[j]][k].jumlah > 0
                  ? parseInt(groupByKodeGroupCOA[keysSubGroup[j]][k].jumlah)
                  : `(${parseInt(
                      groupByKodeGroupCOA[keysSubGroup[j]][k].jumlah
                    )})`}
              </td>
            )}
            <td style={{ width: "25%", border: "1px solid black" }}></td>
          </tr>
        );
      }
      list.push(
        <tr>
          <td
            style={{
              fontWeight: 700,
              paddingLeft: "10px",
              border: "1px solid black",
            }}
          >
            SUBTOTAL {groupByKodeGroupCOA[keysSubGroup[j]][0].namaGroupCOA} :
          </td>
          <td style={{ border: "1px solid black" }}></td>
          {isCetakExcel === false ? (
            <td
              style={{
                width: "25%",
                textAlign: "right",
                borderTop: "1px solid black",
                fontWeight: 700,
                border: "1px solid black",
              }}
            >
              {tempSubTotal > 0
                ? tempSubTotal.toLocaleString("en-EN")
                : `(${tempSubTotal.toLocaleString("en-EN").slice(1)})`}
            </td>
          ) : (
            <td
              style={{
                width: "25%",
                textAlign: "right",
                borderTop: "1px solid black",
                fontWeight: 700,
                border: "1px solid black",
              }}
            >
              {tempSubTotal > 0 ? tempSubTotal : `(${tempSubTotal})`}
            </td>
          )}
          <td style={{ width: "25%", border: "1px solid black" }}></td>
        </tr>
      );
      tempTotal += tempSubTotal;
      tempSubTotal = 0;
    }
    list.push(
      <tr>
        <td style={{ fontWeight: 700, border: "1px solid black" }}>
          TOTAL {neracasData[keys[j]][0].jenisCOA} :
        </td>
        <td style={{ width: "25%", border: "1px solid black" }}></td>
        <td style={{ width: "25%", border: "1px solid black" }}></td>
        {isCetakExcel === false ? (
          <td
            style={{
              width: "25%",
              textAlign: "right",
              fontWeight: 700,
              border: "1px solid black",
            }}
          >
            {tempTotal > 0
              ? tempTotal.toLocaleString("en-EN")
              : `(${tempTotal.toLocaleString("en-EN").slice(1)})`}
          </td>
        ) : (
          <td
            style={{
              width: "25%",
              textAlign: "right",
              fontWeight: 700,
              border: "1px solid black",
            }}
          >
            {tempTotal > 0 ? tempTotal : `(${tempTotal})`}
          </td>
        )}
      </tr>
    );
    if (neracasData[keys[j]][0].jenisCOA === "AKTIVA") {
      tempTotal = 0;
    }
  }

  const { onDownload } = useDownloadExcel({
    currentTableRef: tableRef.current,
    filename: "LaporanNeracaPercobaan",
    sheet: "LaporanNeracaPercobaan",
  });

  if (loading) {
    return <Loader persenLoading={persenLoading} />;
  }

  const textRight = {
    textAlign: screenSize >= 650 && "right",
  };

  return (
    <Container>
      <h3>Accounting</h3>
      <h5 style={{ fontWeight: 400 }}>Neraca Percobaan</h5>
      <Typography sx={subTitleText}>
        Periode : {user.tutupperiode.namaPeriode}
      </Typography>
      <hr />
      <Box sx={spacingTop}>
        {/* <Form onSubmit={tampilPdf}>
          <Button variant="contained" startIcon={<SearchIcon />} type="submit">
            LIHAT
          </Button>
        </Form> */}

        <Form noValidate validated={validated} onSubmit={tampilPdf}>
          <Row>
            <Col sm={6}>
              <Form.Group
                as={Row}
                className="mb-3"
                controlId="formPlaintextPassword"
              >
                <Form.Label column sm="3" style={textRight}>
                  Dari :
                </Form.Label>
                <Col sm="9">
                  <DatePicker
                    required
                    dateFormat="dd/MM/yyyy"
                    selected={dariTanggal}
                    minDate={new Date(user.tutupperiode.dariTanggal)}
                    maxDate={new Date(user.tutupperiode.sampaiTanggal)}
                    customInput={<Form.Control required />}
                    onChange={(date) => setDariTanggal(date)}
                  />
                </Col>
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col sm={6}>
              <Form.Group
                as={Row}
                className="mb-3"
                controlId="formPlaintextPassword"
              >
                <Form.Label column sm="3" style={textRight}>
                  Sampai :
                </Form.Label>
                <Col sm="9">
                  <DatePicker
                    required
                    dateFormat="dd/MM/yyyy"
                    selected={sampaiTanggal}
                    minDate={new Date(user.tutupperiode.dariTanggal)}
                    maxDate={new Date(user.tutupperiode.sampaiTanggal)}
                    customInput={<Form.Control required />}
                    onChange={(date) => setSampaiTanggal(date)}
                  />
                </Col>
              </Form.Group>
            </Col>
          </Row>
          <Button variant="contained" startIcon={<SearchIcon />} type="submit">
            LIHAT
          </Button>
        </Form>
      </Box>

      {previewPdf && (
        <div style={{ marginTop: "10px" }}>
          <ButtonGroup variant="outlined" color="secondary">
            <Button startIcon={<PrintIcon />} onClick={generatePDF}>
              PDF
            </Button>
            <Button
              startIcon={<SearchIcon />}
              onClick={() => {
                setIsCetakExcel(true);
                setTimeout(() => {
                  onDownload();
                }, "1000");
              }}
            >
              Excel
            </Button>
          </ButtonGroup>
        </div>
      )}
      <div ref={reportTemplateRef} id="content" style={pdfContainer}>
        <div style={{ visibility: previewPdf === true ? "visible" : "hidden" }}>
          <p>
            {setting.namaPerusahaan} - {setting.alamatPerusahaan}
          </p>
          <p>({setting.kabupatenPerusahaan})</p>
          <p>{setting.kotaPerusahaan}</p>
          <p>NO. TELP. {setting.teleponPerusahaan}</p>
          <p>
            Dicetak Oleh: {user.username} | Tanggal:
            {` ${nowDate.getDate().toLocaleString("en-EN", {
              minimumIntegerDigits: 2,
              useGrouping: false,
            })}-${(nowDate.getMonth() + 1).toLocaleString("en-EN", {
              minimumIntegerDigits: 2,
              useGrouping: false,
            })}-${nowDate.getFullYear()} `}{" "}
            | Jam:{" "}
            {` ${nowDate.getHours().toLocaleString("en-EN", {
              minimumIntegerDigits: 2,
              useGrouping: false,
            })}-${(nowDate.getMinutes() + 1).toLocaleString("en-EN", {
              minimumIntegerDigits: 2,
              useGrouping: false,
            })}-${nowDate.getSeconds()} `}
          </p>
          <h5 style={{ textAlign: "center", fontWeight: "700" }}>
            Laporan Neraca
          </h5>
          <p>
            Dari Tanggal :
            {` ${dariTanggal.getDate().toLocaleString("en-EN", {
              minimumIntegerDigits: 2,
              useGrouping: false,
            })}-${(dariTanggal.getMonth() + 1).toLocaleString("en-EN", {
              minimumIntegerDigits: 2,
              useGrouping: false,
            })}-${dariTanggal.getFullYear()} `}
            S/D :
            {` ${sampaiTanggal.getDate().toLocaleString("en-EN", {
              minimumIntegerDigits: 2,
              useGrouping: false,
            })}-${(sampaiTanggal.getMonth() + 1).toLocaleString("en-EN", {
              minimumIntegerDigits: 2,
              useGrouping: false,
            })}-${sampaiTanggal.getFullYear()}`}
          </p>
          <table class="styled-table" ref={tableRef}>
            <tbody>
              <tr>
                <th style={{ border: "1px solid black" }}></th>
                <th style={{ border: "1px solid black" }}></th>
                <th style={{ border: "1px solid black" }}></th>
                <th style={{ border: "1px solid black" }}></th>
              </tr>
              {list}
            </tbody>
          </table>
        </div>
      </div>
    </Container>
  );
};

export default NeracaPercobaan;

const subTitleText = {
  fontWeight: "900",
};

const spacingTop = {
  mt: 4,
};

const pdfContainer = {
  padding: "20px",
  letterSpacing: "0.01px",
  fontSize: "12px",
  fontFamily: "sans-serif",
  width: "1000px",
};
